import type { SxProps, Theme } from '@mui/material/styles';
import BookImageAspectCropPreview from './BookImageAspectCropPreview';
import {
  BOOK_COVER_PROMO_IMAGE_HEIGHT_PX,
  BOOK_COVER_PROMO_IMAGE_WIDTH_PX,
} from './constants';

type CoverImageAppAspectPreviewProps = {
  file: File | null;
  storageKey: string;
  imageSx?: SxProps<Theme>;
  variant?: 'cover' | 'promo';
};

const CAPTION_BY_VARIANT = {
  cover:
    'Сүүдэртэй хэсэг нь апп дээр 1200×1520 харьцааны цонхонд бүрэн харагдахгүй; төвд таслагдах хэсгийг харуулна.',
  promo:
    'Сүүдэртэй хэсэг нь апп дээр 1200×1520 харьцааны промо зургийн цонхонд бүрэн харагдахгүй; төвд таслагдах хэсгийг харуулна.',
} as const;

/** Cover / promo preview with 1200×1520 centered cover crop guide. */
export default function CoverImageAppAspectPreview({
  file,
  storageKey,
  imageSx,
  variant = 'cover',
}: CoverImageAppAspectPreviewProps) {
  return (
    <BookImageAspectCropPreview
      file={file}
      storageKey={storageKey}
      imageSx={imageSx}
      frameWidthPx={BOOK_COVER_PROMO_IMAGE_WIDTH_PX}
      frameHeightPx={BOOK_COVER_PROMO_IMAGE_HEIGHT_PX}
      caption={CAPTION_BY_VARIANT[variant]}
    />
  );
}
